import { Autocomplete, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { Field, FieldProps } from "formik"
import { messageSVC } from "message/service"
import { normalizeSync } from "normalize-diacritics"
import React from "react"
import { IUserTag } from "user-tag/model"
import { createUserTag, getAllUserTagsInStore } from "user-tag/tools/common"

interface IFieldTagsProps {
  disabled?: boolean
  userTagIds: number[]
  sx?: any
}

const FIELD_NAME: string = "main.userTagIds"

export const FieldTags = React.memo(({ disabled, userTagIds, sx }: IFieldTagsProps) => {
  const [loadingText, setLoadingText] = React.useState("")
  return (
    <Field>
      {({ form: { setFieldValue } }: FieldProps) => {
        const allUserTags = getAllUserTagsInStore()
        const onEnter = async (inputValue: string) => {
          setLoadingText(translate("tag.creating"))
          try {
            const normalizedInputValue = normalizeSync(inputValue)
            let tag: IUserTag = allUserTags.find(t => t.normalizedName === normalizedInputValue)
            if (!tag) {
              tag = await createUserTag(inputValue)
              messageSVC.info(translate("tag.new.created", tag.name))
            } else if (userTagIds.includes(tag.id)) {
              messageSVC.info(translate("tag.already.selected", inputValue))
            }
            setFieldValue(FIELD_NAME, [...userTagIds, tag.id])
            setLoadingText("")
          } catch (error) {
            setLoadingText("")
            messageSVC.error(translate("tag.creating.error"))
          }
        }
        const selectedUserTags = allUserTags.filter(t => userTagIds.includes(t.id))
        return (
          <Autocomplete
            sx={{ ...sx, "& input": { fontSize: ".8rem", pr: "1.8rem !important" } }}
            id={FIELD_NAME}
            size="small"
            multiple
            options={allUserTags}
            disabled={disabled}
            getOptionLabel={option => option.name}
            value={selectedUserTags}
            filterSelectedOptions
            onChange={(_event, newSelectedUserTags) =>
              setFieldValue(
                FIELD_NAME,
                newSelectedUserTags.map(t => t.id)
              )
            }
            onKeyUp={event => {
              event.stopPropagation()
              event.preventDefault()
              if (event.key === "Enter") {
                const value: string = (event.target as any).value
                if (!value) {
                  return
                }
                onEnter(value)
              }
            }}
            loading={loadingText !== ""}
            loadingText={loadingText}
            renderInput={params => <TextField {...params} label={translate("label.tag.title")} />}
          />
        )
      }}
    </Field>
  )
})
